import { type FetchEventSourceInit } from '@microsoft/fetch-event-source'

import { type ParameterID } from '@flecto/types'

import { getApiEventSourceClient } from '../../../services/getApiEventSourceClient'

export type GetBookingInsuranceStatusOptions = FetchEventSourceInit & {
  wait?: number
}

/**
 * Get insurance status for booking.
 * This endpoint returns an EventSource, to be handled by who uses this
 * function.
 *
 * @endpoint GET /api/saas/me/bookings/{bookingId}/insurances/status
 * @scope saas
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventSource
 */
export function getBookingInsuranceStatus(
  bookingId: ParameterID,
  options?: GetBookingInsuranceStatusOptions
) {
  const eventSource = getApiEventSourceClient()
  let path = `/api/saas/me/bookings/${bookingId}/insurances/status`

  if (options?.wait) {
    path = `${path}?wait=${options.wait}`
  }

  return eventSource.get(path, options)
}
